/**
 * Common Primitives and General Constants
 * Contains basic primitive values, regex patterns, and general-purpose constants
 */

export const FALSE_STATE = false;
export const TRUE_STATE = true;

export const FIRST_ITEM = 0,
  INITIAL_INDEX = 0,
  POSITION_ZERO = 0,
  FISRT_TAB = 0,
  ID_INITIAL_VALUE = 0,
  AVERAGE_INITIAL = 0,
  DEFAULT_LENGTH = 0,
  ID_VALUE_EMPTY = 0,
  NO_CHAPTERS = 0,
  NO_OBJECT_KEY = 0,
  DISABLED_DAY_BY_DEFAULT = 0,
  NO_DAYS_EXPIRED = 0,
  PERCENTAGE_MIN = 0,
  INITIAL_PAGE = 0,
  ORDER_EQUAL = 0;

export const SECOND_ITEM = 1,
  CHAPTER_INDEX_ONE = 1,
  SLICE_FIRST_ITEM = 1,
  ONE_ELEMENT = 1,
  ONE_INDEX = 1,
  ONE_STEP = 1,
  INITIAL_PAGE_NUMBER = 1,
  ORDER_AFTER = 1;

export const THIRD_ITEM = 2,
  SECOND_CHAPTER_TYPE = 2,
  HALF = 2;

export const MONTH_DATE_LIMIT = 6;

export const ONE_HUNDRED = 100,
  PERCENTAGE_MAX = 100;

export const LAST_ARRAY_ELEMENT = -1,
  ORDER_BEFORE = -1;

export const EMPTY_STRING = '';
export const HTTP_PROTOCOL = 'http://';
export const HTTPS_PROTOCOL = 'https://';
export const AMPERSAND_STRING = '&';
export const EQUAL_STRING = '=';
export const SPACE_STRING = ' ';
export const NAME_STRING = 'name';
export const SCORE_STRING = 'score';
export const STATE_STRING = 'state';
export const YOU_STRING = 'Tu';
export const CLASSROOM_STRING = 'classroom';
export const L_STRING = 'L';
export const COMMA_WITH_SPACE_STRING = ', ';
export const DOUBLE_SPACED_DASH = ' - ';
export const SLASH_STRING = '/';
export const OPEN_STRING = 'open';
export const CLOSE_STRING = 'close';
export const TEXT = 'text';
export const ADD_EMAIL = 'addEmail';
export const SCORE_AUTO_STRING = 'scoreAuto';
export const SCORENAME_STRING = 'scoreName';
export const AUTOSCORENAME_STRING = 'autoScoreName';
export const PRAGMAPOWER_SCORE_STRING = 'pragmapower_score';
export const HIDE_STRING = 'hide';
export const UNDERLINE = '_';
export const DOUBLE_NEWLINE = '\n\n';
export const REPLACE = 'replace';
export const PAYLOAD_REPLACE = 'replace';
export const CHAPTER = 'chapter';
export const USER_AVATAR_BASE_PATH = 'images/users_avatar';
export const USER_AVATAR_ROUNDED_SUFFIX = '_REDONDA.png';

export const REGEX_SCORE = /\(([^)]+)\)/;
export const REGEX_ATTACHMENT = /^(ftp|http|https):\/\/[^ "]+$/;
export const REGEX_EMAIL_REPLACE = /\./g;
export const LINK_VALIDATOR_REGEX =
  /^[A-Za-z][A-Za-z\d.+-]*:\/*(?:\w+(?::\w+)?@)?[^\s/]+(?::\d+)?(?:\/[\w#!:.?+=&%@\-/]*)?$/;
export const EMAIL_DOT_REPLACER = /\./g;

export enum Numbers {
  zero = 0,
  one = 1,
  two = 2,
  three = 3,
  four = 4,
  five = 5,
  six = 6,
  seven = 7,
  eight = 8,
  nine = 9,
  ten = 10,
  twelve = 12,
  Twenty = 20,
  Thirty = 30,
  fifty = 50,
  Eighty = 80,
  OneHundred = 100,
  fiveHundred = 500,
  oneThousand = 1000,
}

export enum IDS_NUMBERS {
  zero = 0,
  one = 1,
  two = 2,
  three = 3,
  four = 4,
  five = 5,
  six = 6,
  seven = 7,
  eight = 8,
  nine = 9,
  ten = 10,
}

export enum ARRAY_LENGTH {
  zero = 0,
  one = 1,
  two = 2,
  three = 3,
  four = 4,
  five = 5,
  six = 6,
  seven = 7,
  eight = 8,
  nine = 9,
  ten = 10,
}

export enum TIMERS {
  ThousandMS = 1000,
  FiftyMS = 50,
  OneHundredMS = 100,
  ThreeHundredFiftyMS = 350,
  FiveHundredMS = 500,
  OneThousandFiveHundredMS = 1500,
  SixThousandMS = 6000,
  TwoThousandMS = 2000,
}

export enum DELAYS {
  HalfSecond = 500,
  OneSecond = 1000,
  TwoSecondsAndAHalf = 2500,
  ThreeSeconds = 3000,
}

export const TEXT_LENGTH_ONE_THOUSAND = '1000';
export const DEFAUTL_MAX_LENGTH_INPUT = '128';

export enum TEXT_LENGTH {
  FiveHundred = 500,
  Threehundred = 300,
  EightHundred = 800,
  OneThousand = 1000,
  OneFiveHundred = 1500,
  TwoThousand = 2000,
  TwoHundredAndFifty = 250,
}

export const CART_BEHAVIOR_LIMIT = 25;

export const PAGE_SIZE = 30,
  PAGE_SIZE_DEFAULT = 20,
  PAGE_SIZE_DEFAULT_INIT = 24;

export const ANIMATION_DURATION = 200;

export const DATE_FORMAT_ddMM = 'dd MMM, HH:mm';
export const NEXT_ASSESSMENT_DATE_FORMAT = 'YYYY-MM-DD';
export const FORMAT_DATE = 'YYYY-MM-DD';
export const DATE_FORMAT_dd_MM_YYYY = 'dd-MM-YYYY';
export const DATE_FORMAT_DD_MM_YYYY = 'DD/MM/YYYY';
export const DATE_PLACEHOLDER = 'dd-mm-aaaa';
export const COMPLETE_DATE_FORMAT = "d 'de' MMMM 'de' y";
export const DATE_LANGUAGE = 'es';
export const ACTUAL_DAY = 'day';
export const MONTH_DATE = 'M';

export const SPANISH_MONTHS_ABBREVIATED = [
  'ene',
  'feb',
  'mar',
  'abr',
  'may',
  'jun',
  'jul',
  'ago',
  'sep',
  'oct',
  'nov',
  'dic',
] as const;

export const CHAPTER_MAIN_VIEW = 'mainView';
export const CHAPTER_EDIT_VIEW = 'editView';

export const URL_QUERY_START = '?';
export const LOCAL_STORAGE_CHAPTER = 'ch';
export const LOCAL_STORAGE_DEFAULT_ID = '0';
export const ID_PARAMETER = 'id';
export const IN_PROGRESS_LINK = 'enProceso';
export const SEND_INFORMATION_BY_LINK = 'sendInfoByLink';

export const TARGET_OPEN_URL = '_blank';

export const PRODUCTION_HOSTS = ['mapadecrecimiento.pragma.com.co'];

export const CHILD_PROPERTY_SPECIALITY = 'speciality';
export const CHILD_PROPERTY_ROLE = 'rol';
export const emailForm = 'emailForm';
export const PERCENTAGE_SYMBOL = '%';

export function buildUserAvatarUrl(endpoint: string, email: string): string {
  if (!email) return '';
  const key = email.replace(EMAIL_DOT_REPLACER, '_');
  return `${endpoint}/${USER_AVATAR_BASE_PATH}/${key}${USER_AVATAR_ROUNDED_SUFFIX}`;
}

export const getQueryParamsString = (queryParams: Record<string, string | number>) => {
  return Object.keys(queryParams)
    .map((key) => key + EQUAL_STRING + queryParams[key])
    .join(AMPERSAND_STRING);
};
